/* eslint-disable react/jsx-no-literals */
import { Divider } from '@twistopayments/design-system/components/atoms/divider'
import { Flex } from '@twistopayments/design-system/components/atoms/flex'
import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { EventParameters } from '@twisto/utils'

import { formatValue } from './dev-analytics-utils'

type Props = {
  eventName: string
  parameters: EventParameters
}

export const DevAnalyticsToastContent = ({ eventName, parameters }: Props) => (
  <Flex direction="column" wrap="noWrap">
    <Typography
      color="textPrimary"
      fontWeight="medium"
      gutterBottom={parameters != null && Object.keys(parameters).length > 0}
      variant="b2"
    >
      {eventName}
    </Typography>
    {parameters != null && Object.keys(parameters).length > 0 && (
      <>
        <Divider />
        <Flex direction="column" wrap="noWrap">
          {Object.entries(parameters).map(([key, value]) => (
            <Typography key={key} gutterBottom color="textPrimary" variant="b4">
              <Typography
                inline
                color="textSecondary"
                component="span"
                variant="b4"
              >
                {key}:
              </Typography>
              {formatValue(value)}
            </Typography>
          ))}
        </Flex>
      </>
    )}
  </Flex>
)
